import {
	AlertBar,
	Checkbox,
	defaultRichTextEditorFeatures,
	FormItem,
	imageTool,
	RichTextEditor,
	TextInput,
	ValidationError,
	useRichTextEditorIntermediateState,
	RichTextEditorIntermediateStateHandlers
} from "client/Components";
import { SignatureConstraints } from "client/Api/Email/Signatures/Personal/personalSignatureSettings";
import { IObjectInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useState } from "react";
import { ManagedSignatureModel } from "client/Api/Email/EnvironmentSettings/environmentEmailSettings";
import { UserPlaceholderTool } from "./UserPlaceholderTool";

export type ManagedSignatureFormProps = {
	attachable: IObjectInputAttachable<ManagedSignatureModel>;
	signatureConstraints: SignatureConstraints | undefined;
};

export const ManagedSignatureForm = (props: ManagedSignatureFormProps): ReactElement => {
	const {
		attachable,
		signatureConstraints
	} = props;

	const [
		isManagedSignaturePlaceholdersAlertHidden,
		setIsManagedSignaturePlaceholdersAlertHidden
	] = useState<boolean>(false);

	const richTextEditorIntermediateState: RichTextEditorIntermediateStateHandlers = useRichTextEditorIntermediateState();

	return (
		<>
			<FormItem
				label={localize("_SignatureName")}
			>
				<TextInput
					{...attachable.for("name")
						.attachToTextInput()}
				/>
				<ValidationError
					{...attachable.for("name")
						.attachToValidationError()}
				/>
			</FormItem>
			<FormItem>
				<Checkbox
					{...attachable.for("shouldBeInsertedAutomatically")
						.attachToCheckbox()}
					text={localize("_AddSignatureAutomatically")}
				/>
				<ValidationError
					{...attachable.for("shouldBeInsertedAutomatically")
						.attachToValidationError()}
				/>
			</FormItem>
			<FormItem
				label={localize("_Content")}
			>
				<RichTextEditor
					{...attachable.for("content")
						.attachToRichTextEditor(richTextEditorIntermediateState)}
					supportedFeatures={[
						...defaultRichTextEditorFeatures,
						imageTool({
							imageConstraints: signatureConstraints,
							errorMessage: localize("_UploadSignatureImageError")
						})
					]}
					renderCustomTool={UserPlaceholderTool}
					elementModifiers={{
						paragraph: {
							hasNoMargin: true,
						},
						image: {
							verticalAlignment: "bottom"
						}
					}}
				/>
				<ValidationError
					{...attachable.for("content")
						.attachToValidationError()}
				/>
			</FormItem>
			{!isManagedSignaturePlaceholdersAlertHidden && (
				<AlertBar
					kind="info"
					onDismiss={() => setIsManagedSignaturePlaceholdersAlertHidden(true)}
					isInline
				>
					{localize("_ManagedSignaturePlaceholdersExplanation")}
				</AlertBar>
			)}
		</>
	);
};
ManagedSignatureForm.displayName = "ManagedSignatureForm";